import { render, staticRenderFns } from "./AdmArea.vue?vue&type=template&id=20fb3830"
import script from "./AdmArea.vue?vue&type=script&lang=js"
export * from "./AdmArea.vue?vue&type=script&lang=js"
import style0 from "./AdmArea.vue?vue&type=style&index=0&id=20fb3830&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports